<div class="page-loader" *ngIf="isLoading">
    <div class="load">
        <div class="whirly-loader"> </div>
    </div>
    <div class="txt">Loading....</div>
</div>